import { render } from "./AvatarsGroup.vue?vue&type=template&id=0cde5c6b"
import script from "./AvatarsGroup.vue?vue&type=script&lang=js"
export * from "./AvatarsGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__